import React from "react";
import styled from "styled-components";
import Marquee from "react-fast-marquee";

const TechnologiesUsed = () => {
  const technologies = [
    { name: "React", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
    { name: "Node.js", logo: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg" },
    { name: "Express", logo: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png" },
    { name: "MongoDB", logo: "https://webassets.mongodb.com/_com_assets/cms/mongodb_logo1-76twgcu2dm.png" },

    { name: "Tailwind CSS", logo: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
    { name: "HTML5", logo: "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg" },
    { name: "npm", logo: "https://upload.wikimedia.org/wikipedia/commons/d/db/Npm-logo.svg" },
  ];

  return (
    <Wrapper>
      <Title>Nasze technologie</Title>
<Marquee gradient={false} speed={40} pauseOnHover loop={0}>
  {[...technologies, ...technologies].map((tech, index) => (
    <TechCard key={index}>
      <img src={tech.logo} alt={tech.name} />
      <span>{tech.name}</span>
    </TechCard>
  ))}
</Marquee>

    </Wrapper>
  );
};

export default TechnologiesUsed;

// Styled Components
const Wrapper = styled.div`
  background: url('/back.jpg') no-repeat center center fixed;
  background-size: cover;
  padding: 4rem 2rem;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2rem;
  color: #333;
  margin-bottom: 2rem;
  font-weight: bold;
`;

const TechCard = styled.div`
  width: 160px;
  margin-right: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    max-width: 60px;
    max-height: 60px;
    margin-bottom: 0.5rem;
  }

  span {
    font-size: 1rem;
    color: #555;
    font-weight: 500;
  }
`;
